import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    if(filter.length >= environment.searchLength) {
      return items.filter(item => item.fileName.indexOf(filter) !== -1);
    } else {
      return items;
    }
  }

}
